"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _shopList = require("@/api/shop/shopList");
var _wechatEvaluate = require("@/api/evaluate/wechatEvaluate");
var _orderEvaluate = require("@/api/evaluate/orderEvaluate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DishEvaluateIndex',
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        cityId: '',
        orderType: '4',
        scene: '',
        startDate: '',
        endDate: ''
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      // 分页相关
      regionOptions: [],
      storeList: [],
      currentPage: 1,
      pageSize: 10,
      total: 100
    };
  },
  created: function created() {
    var _this = this;
    (0, _shopList.getRegionList)({
      regionId: 1
    }).then(function (res) {
      _this.regionOptions = res.data;
      console.log(_this.formData);
    });
    this.getShops();
    this.loadData();
  },
  methods: {
    // 搜索方法
    handleSearch: function handleSearch() {
      console.log('搜索条件:', this.searchForm);
      // 这里可以调用API获取搜索结果
      this.loadData();
    },
    //时间转换
    formatDate: function formatDate(date) {
      var formatB = function formatB(t) {
        return new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).format(new Date(+t)).replace(/\//g, '-').replace(/\s/, ' ').replace(/:/g, ':');
      };
      return formatB(date);
    },
    // 审核操作
    handleAudit: function handleAudit(row) {
      var _this2 = this;
      this.$confirm('确认审核该评价？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 执行审核操作
        (0, _orderEvaluate.updateOrderEvaluatelndex)({
          id: row.id,
          status: 1
        }).then(function (res) {
          console.log('审核评价:', row);
          _this2.$message.success('审核成功');
          _this2.loadData();
        });
      }).catch(function () {
        _this2.$message.info('已取消审核');
      });
    },
    handleExport: function handleExport(row) {
      var _this3 = this;
      (0, _orderEvaluate.downloadOrderEvaluateList)(this.searchForm).then(function (res) {
        _this3.$message.success('导出成功，请到导出日志下载');
      });
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    getShops: function getShops() {
      var _this4 = this;
      (0, _shopList.getStoreData)().then(function (res) {
        console.log(res.records);
        _this4.storeList = res.records;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 加载数据
    loadData: function loadData() {
      var _this5 = this;
      // 模拟数据加载
      console.log('加载数据 - 页码:', this.currentPage, '每页:', this.pageSize);
      this.tableLoading = true;

      // 实际项目中这里会调用API
      (0, _orderEvaluate.getOrderEvaluatelndex)(this.searchForm).then(function (res) {
        _this5.tableData = res.records;
        _this5.total = res.total;
        _this5.tableLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};